import React, { useState, Fragment, useEffect } from "react";
import styles from "./Applications.module.css";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Space,
  Spin,
  Input,
  Button,
  Table,
  Modal,
  Tag,
  Typography,
} from "antd";
import {
  CloudDownloadOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { fetchUserVal, fetchJsData } from "../../../../api";
import { CSVLink } from "react-csv";
import Highlighter from "react-highlight-words";
const { Search } = Input;
const { Text } = Typography;

const fetchApiConSearch = async (rel, type) => {
  const data = await fetchUserVal("fetConAppApi", {
    firstVal: rel,
    secondVal: rel,
  });
  return data;
};

export const FetchApiConnector = (props) => {
  const [load, setLoad] = useState(props.load);
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);
  const [app, setApp] = useState("");
  const [trig, setTrig] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const ColApi = [
    {
      title: () => {
        return (
          <>
            Application name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">{filteredData.length}</Tag>
            )}
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      width: "14%",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      render: (text, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              setApp(record.current_name);
              setOpenModal(true);
              setTrig(!trig);
            }}
          >
            {record.current_name}
          </a>
        </Space>
      ),
    },
    {
      title: "Notification Method",
      dataIndex: "ongoing_notification_method",
      key: "ongoing_notification_method",
      defaultSortOrder: "descend",
      sorter: (a, b) =>
        a.ongoing_notification_method - b.ongoing_notification_method,
      fixed: "left",
      width: "11%",
    },
    {
      title: "Audit",
      dataIndex: "audit_method",
      key: "audit_method",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.audit_method - b.audit_method,
      fixed: "left",
      width: "9%",
    },
    {
      title: "Listing Support",
      dataIndex: "listing_support",
      key: "listing_support",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.listing_support - b.listing_support,
      fixed: "left",
      width: "10%",
    },
    {
      title: "Forensic Support",
      dataIndex: "forensics_support",
      key: "forensics_support",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.forensics_support - b.forensics_support,
      fixed: "left",
      width: "10%",
    },
    {
      title: "IRM",
      dataIndex: "irm",
      key: "irm",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.irm - b.irm,
      fixed: "left",
      width: "7%",
    },
    {
      title: "DLP",
      dataIndex: "dlp_support",
      key: "dlp_support",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.dlp_support - b.dlp_support,
      fixed: "left",
      width: "6%",
    },
    {
      title: "TSS",
      dataIndex: "tss_support",
      key: "tss_support",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.tss_support - b.tss_support,
      fixed: "left",
      width: "6%",
    },
    {
      title: "Retro Scan Support",
      dataIndex: "retro_scan_support",
      key: "retro_scan_support",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.retro_scan_support - b.retro_scan_support,
      fixed: "left",
      width: "10%",
    },
    {
      title: "Quarantine Destination",
      dataIndex: "quarantine_destination",
      key: "quarantine_destination",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.quarantine_destination - b.quarantine_destination,
      fixed: "left",
      width: "10%",
    },
    {
      title: "BYOK",
      dataIndex: "byok",
      key: "byok",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.byok - b.byok,
      fixed: "left",
      width: "7%",
    },
  ];

  useEffect(() => {
    setLoading(true);
    const crawl = (user, allValues) => {
      if (!allValues) allValues = [];
      for (var key in user) {
        if (typeof user[key] === "object") crawl(user[key], allValues);
        else allValues.push(user[key] + " ");
      }
      return allValues;
    };
    const fetchData = async () => {
      const { data: users } = await fetchApiConSearch(props.usrRel, props.type);
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);
      if (users) setLoading(false);
    };
    fetchData();
  }, [props.submit]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.submit]);

  return (
    <>
      <div>
        <Row gutter={16}>
          {/* <Col className="gutter-row" span={1}></Col> */}
          <Col span={24}>
            <Card
              title={"Release - " + props.usrRel.split('snapshot_v')[1].split('_')[0]}
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <Row>
                  <Col span={21}>
                    <Input
                      onChange={(e) => setSearchVal(e.target.value)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon" />
                      }
                      placeholder="Crawl Search"
                      allowClear
                      enterButton
                    />
                  </Col>
                  <Col span={1}></Col>
                  <Col className="gutter-row" span={2}>
                    {" "}
                    <div>
                      {loading ? (
                        <div>
                          <Spin size="small" />
                        </div>
                      ) : (
                        <Tooltip
                          placement="topRight"
                          title="Download API Connector Report"
                          arrowPointAtCenter
                          // color={"#CCD1D1"}
                          // key={"#2db7f5"}
                        >
                          <CSVLink
                            filename={"API Connector Report.csv"}
                            data={filteredData}
                            className="btn btn-primary"
                          >
                            <CloudDownloadOutlined
                              style={{ fontSize: "29px" }}
                            />
                          </CSVLink>
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                </Row>
              }
            >
              <Fragment>
                <Table
                  rowKey="application_id"
                  size="small"
                  bordered
                  scroll={{ x: 700, y: 900 }}
                  style={{ margin: "2px" }}
                  dataSource={filteredData}
                  columns={ColApi}
                  loading={loading}
                  pagination={{
                    pageSizeOptions: ["10", "30", "60", "100", "1000"],
                    defaultPageSize: ["50"],
                    showSizeChanger: true,
                  }}
                />
              </Fragment>
              <Fragment>
                <OpMod
                  usrRel={props.usrRel}
                  rel={props.rel}
                  type={props.type}
                  app={app}
                  openModal={openModal}
                  trig={trig}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

const OpMod = (props) => {
  const [app, setApp] = useState(props.app);
  const [load, setLoad] = useState(true);
  const [usrRel, setUsrRel] = useState(props.usrRel);
  const [rel, setRel] = useState(props.rel);
  const [modData, setModData] = useState({
    conActName: "conAct",
    conActPol: "",
  });
  const [comp, setComp] = useState(false);
  const [showPol1, setShowPol1] = useState(false);
  const [showPol2, setShowPol2] = useState(false);
  const [show, setShow] = useState(false);
  const openModal = () => setShow(props.openModal);
  const closeModal = () => {
    setShow(false);
    setComp(false);
  };
  const prevRel = rel - 1;
  const ppRel = rel - 2;
  const [compDomData, setCompDomData] = useState([
    {
      release: "",
      actName: "",
      domain: "",
    },
  ]);

  // initial effect
  useEffect(() => {
    setApp(props.app);
    if (props.openModal === true) {
      openModal();
      fetchData();
      setCompDomData([
        {
          release: "",
          actName: "",
          domain: "",
        },
      ]);
    }
  }, [props.app, props.trig]);

  // Compare effect
  useEffect(() => {
    if (!compDomData[0]["release"]) {
      fetchCompData();
    }
  }, [comp]);

  const fetchData = async () => {
    setLoad(true);
    setUsrRel(props.usrRel);
    const fetConActivity = await fetchUserVal("fetConActivity", {
      firstVal: props.usrRel,
      secondVal: props.usrRel,
      thirdVal: props.usrRel,
      fourthVal: props.app,
    });

    const fetConAppAct = await fetchJsData({
      type: "fetch",
      qry: "fetConApiPol",
      firstVal: props.usrRel,
      secondVal: props.usrRel,
      thirdVal: props.usrRel,
      fourthVal: props.app,
    });

    // setRel("snapshot_" + relVersion["version"]);
    setModData({
      conActName: fetConActivity["data"][0]["category_name"],
      conActPol: fetConAppAct["data"][0]["pol"],
    });
    setLoad(false);
  };

  const fetchCompData = async () => {
    setLoad(true);
    setUsrRel(props.usrRel);
    if (show) {
      const domData = await fetchJsData({
        type: "fetch",
        qry: "fetConApiPols",
        preProcFunc: "appPolInfo",
        preProcess: true,
        firstVal: props.app,
        secondVal: "snapshot_v" + ppRel + "_0_0",
        thirdVal: "snapshot_v" + ppRel + "_0_0",
        fourthVal: "snapshot_v" + ppRel + "_0_0",
        fifthVal: "snapshot_v" + prevRel + "_0_0",
        sixthVal: "snapshot_v" + prevRel + "_0_0",
        seventhVal: "snapshot_v" + prevRel + "_0_0",
        eigthVal: "snapshot_v" + rel + "_0_0",
        ninthVal: "snapshot_v" + rel + "_0_0",
        tenthVal: "snapshot_v" + rel + "_0_0",
      });

      // setCompData(actData["data"]);
      setCompDomData(domData["data"]);
    }
    setLoad(false);
  };

  const compare = async () => {
    setShowPol1(false);
    setShowPol2(false);
    setComp(!comp);
  };

  return (
    <Modal
      title={
        load ? (
          <div>
            <Spin size="small" />
          </div>
        ) : (
          <Row gutter={16}>
            <Col className="gutter-row" span={19}>
              <Text keyboard>
                <>{app + " > " + modData["conActName"]}</>
              </Text>
            </Col>

            <Col className="gutter-row" span={2}>
              <Space size="small" align="end">
                <Button
                  type="dashed"
                  shape="round"
                  // icon={<OrderedListOutlined />}
                  onClick={compare}
                  style={{ backgroundColor: "#f0f5ff" }}
                  size="small"
                >
                  compare
                </Button>
                {comp ? (
                  <Tooltip
                    title={
                      <div
                        style={{
                          fontSize: "9px",
                          fontFamily: "Gill, Helvetica, sans-serif",
                        }}
                      >
                        <ul>
                          <li>
                            <p>
                              <Text>No Change</Text>: indicates same as previous
                              release
                            </p>
                          </li>
                          <li>
                            <p>
                              <Text delete type="danger">
                                Red Text
                              </Text>
                              : indicates removed in this release
                            </p>
                            {/* <span style={{ color: "red" }}>Red text</span> */}
                          </li>
                          <li>
                            <p>
                              <Text type="success">Green Text</Text>: indicates
                              added in this release
                            </p>
                          </li>
                        </ul>
                      </div>
                    }
                    color="#425162"
                    // style={{ width: "700px" }}
                  >
                    <InfoCircleOutlined />
                  </Tooltip>
                ) : (
                  <></>
                )}
              </Space>
            </Col>
          </Row>
        )
      }
      visible={show}
      onOk={closeModal}
      confirmLoading={load}
      onCancel={closeModal}
      width={"50%"}
    >
      <Card
        className={styles.chart}
        size="small"
        headStyle={{ border: 2 }}
        bordered={true}
        loading={load}
      >
        {comp ? (
          <>
            <Card
              className={styles.chart}
              title={<Text keyboard> Policy Actions </Text>}
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 1 }}
              bordered={true}
              loading={load}
            >
              {load ? (
                <div>
                  <Spin size="small" />
                </div>
              ) : (
                <>
                  <Table
                    rowKey="appDom_id"
                    size="small"
                    bordered
                    pagination={false}
                    dataSource={compDomData}
                    columns={[
                      {
                        title: () => {
                          return (
                            <div style={{ fontSize: "12px" }}>Release </div>
                          );
                        },
                        dataIndex: "release",
                        key: "release",
                        fixed: "left",
                        width: "10%",
                        render: (text) => (
                          <span style={{ fontSize: "11px" }}>{text}</span>
                        ),
                      },
                      {
                        title: () => {
                          return (
                            <div style={{ fontSize: "12px" }}>Domain </div>
                          );
                        },
                        dataIndex: "polName",
                        key: "polName",
                        fixed: "left",
                        responsive: ["sm"],
                        width: "90%",
                        render: (text, row) => (
                          <>
                            {row.id == 1 ? (
                              text ? (
                                <span style={{ fontSize: "11px" }}>
                                  {text.replaceAll(",", ", ")}
                                </span>
                              ) : (
                                text
                              )
                            ) : row.id == 2 ? (
                              <div
                                onClick={() => {
                                  setShowPol1(!showPol1);
                                }}
                                style={{ fontSize: "11px" }}
                              >
                                {!showPol1 ? (
                                  row.polComp == "No Change" ? (
                                    <a>{row.polComp}</a>
                                  ) : row.polAdded.length != 0 ? (
                                    <Text type="success">{row.polAdded} </Text>
                                  ) : (
                                    <Text delete type="danger">
                                      {row.polRemoved}
                                    </Text>
                                  )
                                ) : (
                                  text
                                )}
                              </div>
                            ) : (
                              <div
                                onClick={() => {
                                  setShowPol2(!showPol2);
                                }}
                                style={{ fontSize: "11px" }}
                              >
                                {!showPol2 ? (
                                  row.polComp == "No Change" ? (
                                    <a>{row.polComp}</a>
                                  ) : row.polAdded.length != 0 ? (
                                    <Text type="success">{row.polAdded} </Text>
                                  ) : (
                                    <Text delete type="danger">
                                      {row.polRemoved}
                                    </Text>
                                  )
                                ) : (
                                  text
                                )}
                              </div>
                            )}
                          </>
                        ),
                      },
                    ]}
                    loading={load}
                  />
                </>
              )}
            </Card>
          </>
        ) : (
          <>
            <Card
              className={styles.chart}
              title={<Text keyboard> Policy Actions </Text>}
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 1 }}
              bordered={true}
              loading={load}
            >
              <Text style={{ fontSize: "12px" }}>{modData["conActPol"]}</Text>
            </Card>
          </>
        )}
      </Card>
    </Modal>
  );
};
